<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Gifts</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Gifts</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="d-flex flex-row justify-content-between">
      <div class="">
        <router-link :to="{ name: 'add-gift-page' }" type="button" class="btn btn-primary">Add</router-link>
      </div>
        
      <div class="">
        <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
          <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
            :class="{ 'change-background': button.status }" @click="onPressBtn(index)" type="button">
            {{ button.name }}
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <p>Only approved gifts that are selected by Marketing will be shown on Takaful Brunei Mobile App</p>

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class>
              <h4 class="card-title mb-3">
                <b>{{ buttons[selectedIndex].name }}</b>
              </h4>


              <div class="table-responsive">
                <table
                  id="tbl_gifts"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th style="width: 5% !important">No.</th>
                      <th style="width: 20% !important">Name</th>
                      <th style="width: 15% !important">Image</th>
                      <th style="width: 15% !important">Qty Total</th>
                      <th style="width: 10% !important">Qty Redeemed</th>
                      <th style="width: 15% !important">Qty Balance</th>
                      <th v-if="current_user_takaful" style="width: 15% !important">Points</th>
                      <th style="width: 15% !important">{{ current_user_takaful ? 'Expiry' : 'Price' }}</th>
                      <th style="width: 5% !important">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(gift, index) in gifts" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ gift.name }}</td>
                      <td>
                        <img :src="gift.image" class="img-fluid" />
                      </td>
                      <td>{{ gift.quantity }}</td>
                      <td>{{ gift.quantity_selected }}</td>
                      <td>{{ gift.quantity_remained }}</td>
                      <td v-if="current_user_takaful">{{ gift.points }}</td>
                      <td>{{ current_user_takaful ? gift.expiry : gift.price }}</td>
                      <td>
                        <router-link :to="goTo(gift.id)" class="btn btn-primary btn-block">View Details</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>


<script>
import { getGifts } from "@/services/GiftServices";

export default {
  data() {
    return {
      gifts: [],
      buttons: [
        { status: true, name: "Approved" },
        { status: false, name: "Pending" },
      ],

      clone_gifts: [],

      approved_gifts: [],
      pending_gifts: [],

      selectedIndex: 0,
      dataTable: null,
      current_user_takaful: false,
    }
  },

  methods: {
    goTo(id) {
      return `/gift/edit/${id}`;
    },

    async fetchData() {
      try {
        const response = await getGifts();

        if(response.data.success) {
          this.approved_gifts = response.data.data.approved;
          this.pending_gifts = response.data.data.pending;
        }

        this.checkData();
      } catch (e) {
        console.error(e)
      }
    },

    handleStatus(gift) {
      const findItem = this.gifts.find(item => item.id === gift.id);

      if(findItem) {
        findItem.statusInt = !findItem.statusInt
      }
    },

    onPressBtn(int) {
      this.selectedIndex = int;

      this.buttons.forEach((button, index) => {
        button.status = int === index;
      });

      if (this.dataTable) {
        this.dataTable.destroy();
      }

      this.checkData();

      this.$nextTick(() => {
        this.dataTable = this.loadTable("#tbl_gifts");
      });
    },

    checkData() {
      switch (this.selectedIndex) {
        case 0:
          this.gifts = this.approved_gifts;
          return;
        case 1:
          this.gifts = this.pending_gifts;
          return;
      }
    },

    destroyDataTable(name) {
      $(name).DataTable().destroy();
    },

    loadTable(name) {
      return $(name).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6],
              columns: ':not(:last-child)',
            }
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
            pageSize: 'LEGAL',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6],
              columns: ':not(:last-child)',
            }
          }
        ]
      });
    },

    checkCurrentUser() {
      const user = JSON.parse(localStorage.getItem('user'));
      this.current_user_takaful = user.username === 'vendor.takaful' ? true : false;
    },
  },

  async mounted() {
    this.checkCurrentUser()
    await this.fetchData();
    this.dataTable = this.loadTable("#tbl_gifts");
  },
}
</script>


<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
